// Очередь домашек админа — та же страница и та же ручка `/curator/homework`, что у куратора: отдельной
// админской ручки нет. Разницу делает сервер по роли — админ видит сдачи всех учеников, куратор только своих.
import { CuratorHomeworkPage } from '@/pages/curator/CuratorHomeworkPage';
export const AdminHomeworkPage = CuratorHomeworkPage;
